import { render, staticRenderFns } from "./BaseHeaderBox.vue?vue&type=template&id=c5f296bc&scoped=true"
import script from "./BaseHeaderBox.vue?vue&type=script&lang=js"
export * from "./BaseHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./BaseHeaderBox.vue?vue&type=style&index=0&id=c5f296bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f296bc",
  null
  
)

export default component.exports